/* eslint-disable prefer-destructuring */
// * Primary
// * Secondary
// * Accent

// * Neutral_1
// * Neutral_2
// * Neutral_3

// * Font = Light / Dark
// * Button Style = Solid / Ghost

export const theme = {
  borders: {},
  borderWidths: [],
  borderStyles: [],
  radii: [],
  document: { maxWidth: '1600px', gapColumn: '2.5rem', gapRow: '2.5rem' },
  article: { wide: { maxWidth: '1132px' }, narrow: { maxWidth: '890px' } },
  breakpoints: [
    '374px',
    '413px',
    '815px',
    '1023px',
    '1279px',
    '1439px',
    '1640px',
  ],
  media: {
    grid: '1600px',
    'grid-gutter': ['10px', '20px', '60px', '60px'],
  },
  colors: {
    // * Spin Master Brand Color Palette
    spinTextDark: '#001655',
    spinTextMid: '#414042',
    spinDark: '#00168A',
    spinLight: '#247EE2',
    spinSecondaryOne: '#FFBC00',
    spinSecondaryTwo: '#FFE455',
    spinSecondaryThree: '#7BE6CF',
    spinSecondaryFour: '#E4EDEB',
    spinAccentOne: '#B42A86',
    spinAccentTwo: '#FF55C5',
    spinAlert: '#FF1145',
    spinTest: '990099',
    // * Generic Colors
    black: '#000000',
    white: '#FFFFFF',
    whiteSnow: '#FAFAFA',
    transparent: 'transparent',
    default: '#E8EFEE',
    // * Form Input Colors
    formInputBorder: '#DFDFDF',
  },
  fonts: {
    sans: 'Open Sans',
    rubik: 'Rubik',
  },
  fontSizes: [],
  'font-weights': {
    regular: 400,
    'semi-bold': 600,
    bold: 700,
  },
  lineHeights: [],
  letterSpacings: [],
  textDecoration: {},
  space: ['10px', '20px', '30px'],
  sizes: [],
  shadows: {
    small: '0px 2px 4px 0px rgba(0, 0, 0, 0.16)',
  },
  transitions: [],
  zIndices: [0, 1, 2, 3, 6, 12, 24, 48, 96],
  typeStyles: {
    home: {
      card: {
        imageAbove: {
          heading: `font-size:2.25rem;
          line-height:2.5rem;`,
          description: `font-size:1.0625rem;
          line-height:1.6875rem;`,
          mobile: {
            heading: `font-size:1.875rem;
            line-height:2.1875rem;`,
            subheading: ``,
            description: `font-size:1rem;
            line-height:1.625rem;`,
          },
        },
      },
    },
    banner: {
      hero: {
        heading: `font-size:4.0625rem;
        line-height:4.25rem;`,
        subheading: `font-size:2.125rem;
        line-height:2.625rem;`,
        description: `font-size:1.3125rem;
        line-height:1.9375rem;`,
        mobile: {
          heading: `font-size:2.5rem;
          line-height:2.8125rem;`,
          subheading: `font-size:1.125rem;
          line-height:1.5rem;`,
          description: `font-size:1rem;
          line-height:1.625rem;`,
        },
      },
      onpage: {
        heading: `font-size:2.8125rem;
        line-height:3.4375rem;`,
        subheading: `font-size:`,
        description: `font-size:1.0625rem;
        line-height:1.6875rem;`,
        mobile: {
          heading: `font-size:1.3125rem;
          line-height:1.875rem;`,
          subheading: `font-size:1.125rem;
          line-height:1.5rem;`,
          description: `font-size:1rem;
          line-height:1.625rem;`,
        },
      },
      hero_wide: {
        heading: `font-size:4.0625rem;
          line-height:4.25rem;`,
        subheading: `font-size:2.125rem;
          line-height:2.625rem;`,
        description: `font-size:1.0625rem;
          line-height:1.6875rem;`,
      },
      default: {},
    },
    card: {
      imageAbove: {
        heading: `font-size:1.875rem;
        line-height:2.5rem;`,
        description: `font-size:1.0625rem;
        line-height:1.6875rem;`,
        mobile: {
          heading: `font-size:1.3125rem;
          line-height:1.875rem;`,
          subheading: `font-size:1rem;
          line-height:1.625rem;`,
          description: `font-size:1rem;
          line-height:1.625rem;`,
        },
      },
      imageBehind: {
        heading: `font-size:2.8125rem;
        line-height:3.4375rem;`,
        description: `font-size:1.0625rem;
        line-height:1.6875rem;`,
        mobile: {
          heading: `font-size:1.875rem;
          line-height:2.1875rem;`,
          subheading: ``,
          description: `font-size:0.875rem;
          line-height:1.5rem;`,
        },
      },
    },
  },
};

export const defaultTheme = {
  primary: '#6F1F3A',
  secondary: '#FF5C0B',
  accent: '#A9E7F5',
  text_light: '#FFFFFF',
  text_primary: '#FFFFFF',
};

// * Custom Breakpoints
theme.breakpoints.xs = theme.breakpoints[0];
theme.breakpoints.sm = theme.breakpoints[1];
theme.breakpoints.md = theme.breakpoints[2];
theme.breakpoints.lg = theme.breakpoints[3];
theme.breakpoints.xl = theme.breakpoints[4];
theme.breakpoints.max = theme.breakpoints[5];
theme.breakpoints.ultra = theme.breakpoints[6];

// * Font Themes
theme.fonts.primary = theme.fonts.sans;
theme.fonts.secondary = theme.fonts.brush;

// * Primary Theme Colours
theme.colors.primary = theme.colors.white;
theme.colors.secondary = theme.colors.spinSecondaryOne;

// * Standard Text Theme Colors
theme.colors['text-light'] = theme.colors.white;
theme.colors['text-dark'] = theme.colors.black;

// * Primary Text Theme Colors
theme.colors['text-primary'] = theme.colors.white;
theme.colors['text-secondary'] = theme.colors.black;

export default theme;
